module.exports = __webpack_public_path__ + "static/media/image_18.9e84a80c.jpg";